export function forceDataDownload(data: any, type: string, filename: string) {
  const url = URL.createObjectURL(new Blob(data, {type: type}));

  openWindow(url, filename);
}

export function openWindow(href: string, filename: string = '') {
  const link = document.createElement('a');
  link.href = href;
  link.target = '_blank';

  if (filename) {
    link.download = filename;
  }

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/force-download.ts